export class URLParamsBuilder {
  private url: string;
  private queryParams: { [key: string]: any };

  constructor(url: string) {
    this.url = url;
  }

  addQueryParams(params: { [key: string]: any }) {
    this.queryParams = params;
    return this;
  }

  build(): string {
    if (!this.queryParams) {
      return this.url;
    }
    const queryParamsArr = [];
    const keys = Object.keys(this.queryParams);
    for (const key of keys) {
      if (this.queryParams[key] != null) {
        const queryParam = `${key}=${this.queryParams[key]}`;
        queryParamsArr.push(queryParam);
      }
    }
    return `${this.url}?` + queryParamsArr.join('&');
  }
}
